































// eslint-disable-next-line no-unused-vars
import { Tree } from 'element-ui';
// eslint-disable-next-line no-unused-vars
import { TreeData } from 'element-ui/types/tree';
import { listFactory, ListLoadBehavior } from '@/main/pages';
import { types } from '@/modules/administrace/logSysUdalosti/store/types';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { TABLE_DATA } from '@/main/store/listEditTypes';
// eslint-disable-next-line no-unused-vars
import { Row, Table, Column, arrayToTable } from '@/main/utils/table';
import { apiProvider } from '@/modules/administrace/logSysUdalosti/api';

import { NAME } from './constants';
import { store } from './store/list';


export default listFactory(NAME, store).extend({
	components: {
		PracovnikSelect: Pracovnik.components.Select,
	},
	data() {
		return {
			listLoadDefault: ListLoadBehavior.NO_LOAD,
			treeProps: {
				children: 'children',
				label: 'Text',
			},
			tableDetail: arrayToTable([]),
			detailLoading: false,
			treeMcotEnum: [],
			McostEnumChecked: [] as number[],
			McotEnumTreeChecked: [] as number[],
			McotEnumTree: [] as { McotKategId: number, McotEnum: number, Text: string, children: TreeData[] }[],
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				pracovnik: `${this.storeUri}/${types.mutations.PRACOVNIK_SELECT_MAPPER}`,
			};
		},
	},
	watch: {
		McostEnum(newVal, oldVal) {
			if (oldVal.length === 0) {
				this.McostEnumChecked = this.getDefaultChecked(newVal);
			}
		},
		async McotEnum(newVal, oldVal) {
			if (oldVal.length === 0) {
				await this.getMcotEnumTree(newVal);
				const defaultVal = [] as number[];
				this.McotKategEnum.forEach((element: any) => defaultVal.push(element.McotKategId));
				this.McotEnumTreeChecked = defaultVal;
			}
		},
	},
	created(): void {
		this.mainCollapse = ['fraFiltr'];
	},
	methods: {
		getLocalizedText(text: string) {
			return this.LocalizePopisPoli(text);
		},
		tableData() {
			const McotEnumWithGroups = (this.$refs.mainTree as any).getCheckedNodes();
			McotEnumWithGroups.forEach((el: any, index: number) => {
				if (el.children) {
					delete McotEnumWithGroups[index];
				}
			});
			const McotEnum = McotEnumWithGroups.filter(() => true);
			return this.$store.dispatch(`${this.storeUri}/${TABLE_DATA}`, {
				VstupDatOd: this.VstupDatOd,
				VstupDatDo: this.VstupDatDo,
				PracovnikId: this.PracovnikId,
				McotEnum,
				McostEnum: (this.$refs.additionalTree as Tree).getCheckedNodes(),
			});
		},
		getDefaultChecked(data: Record<string, string | number>[]): number[] {
			return data.map((el) => Number(el.McostEnum));
		},
		addToTree(elSubTree: Record<string, any>) {
			this.McotEnumTree.find((elGroupTree: any) => elGroupTree.McotKategId === elSubTree.McotKategId)!.children.push(elSubTree);
		},
		getMcotEnumTree(data: []) {
			this.McotEnumTree = this.McotKategEnum;
			this.McotEnumTree.forEach((record: any) => {
				record.children = [];
				record.McotEnum = record.McotKategId;
			});
			data.forEach((elSubTree: Record<string, any>) => {
				this.addToTree(elSubTree);
			});
		},
		async handleExpandedRowUpdate(row: Row | null) {
			this.tableDetail.loadingCount += 1;
			if (row !== null) {
				const ROW_ID = 0;
				this.tableDetail = arrayToTable((await apiProvider.getDetail(row.cells[ROW_ID])).data, this.tableDetail.loadingCount);
				this.tableDetail.columns.forEach((col: Column) => {
					if (col.propertyName === 'Text' || col.propertyName === 'OldValue' || col.propertyName === 'NewValue') {
						col.isVisible = true;
					}
				});
			}
			this.tableDetail.loadingCount -= 1;
		},
	},
});
